const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
          expired: "Sua sessão expirou. Entre novamente.",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Você precisará ler o QR Code novamente. A conexão fica desligada até alguém iniciá-la aqui: nem a reconexão automática nem a subida do servidor a religam.",
        },
        canais: {
          whatsapp: "WhatsApp",
          whatsappOficial: "WhatsApp API Oficial",
          whatsappVoz: "WhatsApp (voz)",
          telegram: "Telegram",
          facebook: "Facebook",
          instagram: "Instagram",
          redeSocial: "Rede social",
          viaZernio: "{{canal}} (Zernio)",
          canaisDaMeta:
            "Facebook, Instagram e WhatsApp API Oficial entram pelos botões próprios, ao lado de “Adicionar canal”.",
        },
        buttons: {
          add: "Adicionar canal",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar conexão",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Conexão salva com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          importMessage: "Deseja importar todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar departamento",
          edit: "Editar departamento",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um atendimento para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      tickets: {
        toasts: {
          deleted: "O atendimento que você estava vendo foi apagado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimentos e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir atendimento",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para departamento",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione um departamento",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com essa situação ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Novo atendimento",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Atendimentos",
          contacts: "Contatos",
          quickAnswers: "Respostas rápidas",
          queues: "Departamentos & Chatbot",
          tags: "Tags",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Departamentos",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar departamento",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos desse departamento continuarão existindo, mas não terão mais nenhum departamento atribuído.",
        },
      },
      queueSelect: {
        inputLabel: "Departamentos",
      },
      tags: {
        title: "Etiquetas",
        table: {
          name: "Nome",
          color: "Cor",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar etiqueta",
        },
        toasts: {
          deleted: "Etiqueta excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos com essa etiqueta continuarão existindo, mas não terão mais essa etiqueta atribuída.",
        },
      },
      tagModal: {
        title: {
          add: "Adicionar etiqueta",
          edit: "Editar etiqueta",
        },
        form: {
          name: "Nome",
          color: "Cor",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Etiqueta salva com sucesso!",
      },
      tagSelect: {
        inputLabel: "Etiquetas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimentos abertos deste usuário serão movidos para o departamento.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite este atendimento para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Apagar o atendimento do contato",
          message:
            "Atenção! Todas as mensagens deste atendimento serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_STATUS_POST_FOUND:
          "Este status não existe mais ou é de outra empresa.",
        ERR_STATUS_NAO_ENCONTRADO:
          "Este status não existe mais.",
        ERR_STATUS_ALREADY_PUBLISHED:
          "Este status já foi publicado. Depois de publicado só dá para trocar o fluxo; para mudar o resto, crie outro a partir dele.",
        ERR_STATUS_JA_PUBLICANDO:
          "Este status já está sendo publicado. Aguarde alguns segundos.",
        ERR_STATUS_AUDIENCE_REQUIRED:
          "Escolha ao menos um contato ou etiqueta em “Quem vê”.",
        ERR_STATUS_AUDIO_NAO_SUPORTADO:
          "Esta conexão não publica status de áudio. Use texto, imagem ou vídeo, ou outra conexão.",
        ERR_STATUS_CANAL_NAO_SUPORTADO:
          "Esta conexão não publica status. Escolha uma conexão de WhatsApp que publique.",
        ERR_STATUS_INVALID_FLOW:
          "O fluxo escolhido não existe mais. Escolha outro ou deixe sem fluxo.",
        ERR_STATUS_INVALID_NAME:
          "Dê um nome ao status (pelo menos 2 letras).",
        ERR_STATUS_INVALID_WHATSAPP:
          "Escolha uma conexão válida para publicar o status.",
        ERR_STATUS_MEDIA_REQUIRED:
          "Envie o arquivo do status antes de salvar.",
        ERR_STATUS_SEM_DESTINATARIOS:
          "Nenhum contato se encaixa em “Quem vê”: o status não teria para quem aparecer.",
        ERR_STATUS_SEM_MIDIA:
          "O arquivo deste status não foi encontrado. Envie de novo.",
        ERR_STATUS_TEXT_REQUIRED:
          "Escreva o texto do status.",
        ERR_WAHA_SEM_BASE_URL:
          "O WhatsApp v2 está sem endereço de servidor. Escolha um servidor na conexão ou fale com o suporte.",
        ERR_WAHA_SEM_API_KEY:
          "O WhatsApp v2 está sem a chave de acesso do servidor. Escolha um servidor na conexão ou fale com o suporte.",
        ERR_WAHA_SEM_URL_DE_WEBHOOK:
          "Falta o endereço público do sistema na configuração do servidor — sem ele o WhatsApp v2 não tem para onde entregar as mensagens. Fale com o suporte.",
        ERR_WAHA_STATUS_SEM_DESTINATARIOS:
          "Escolha para quem publicar o status. Sem ninguém na lista, ele não é publicado.",
        ERR_WAHA_MIDIA_SEM_CONTEUDO:
          "O arquivo chegou vazio e não foi enviado. Anexe de novo.",
        ERR_WAHA_ARQUIVO_GRANDE:
          "O arquivo passa do tamanho que o WhatsApp v2 aceita.",
        ERR_WAHA_ARQUIVO_FORA_DE_ROTA:
          "O arquivo não pôde ser baixado do WhatsApp v2.",
        ERR_UAZAPI_SEM_BASE_URL:
          "O WhatsApp v3 está sem endereço de servidor. Escolha um servidor na conexão ou fale com o suporte.",
        ERR_UAZAPI_ARQUIVO_GRANDE:
          "O arquivo passa do tamanho que o WhatsApp v3 aceita.",
        ERR_UAZAPI_MIDIA_VAZIA:
          "O WhatsApp v3 entregou o arquivo vazio. Peça para o cliente reenviar.",
        // Horário de atendimento: o código vem com o dia ou a data depois de
        // ":", então o prefixo é o que casa aqui — a tela já mostra o erro na
        // linha; o toast é a rede de quem salvou por outro caminho.
        ERR_SCHEDULE_END_BEFORE_START:
          "O fechamento precisa ser depois da abertura. Para atender de madrugada, use duas faixas: 22:00–23:59 e, no dia seguinte, 00:00–02:00.",
        ERR_SCHEDULE_OVERLAP:
          "Há faixas de horário que se sobrepõem no mesmo dia.",
        ERR_SCHEDULE_INVALID_RANGE: "Preencha os dois horários da faixa.",
        ERR_SCHEDULE_TOO_MANY_RANGES:
          "São no máximo três faixas por dia.",
        ERR_SCHEDULE_INVALID_DAY: "Dia da semana inválido no horário.",
        ERR_SCHEDULE_INVALID_DATE:
          "Data inválida: confira o dia, o mês e o ano.",
        ERR_SCHEDULE_DUPLICATE_DATE:
          "Já existe uma exceção cadastrada nesta data.",
        ERR_SCHEDULE_INVALID_TIMEZONE: "Fuso horário desconhecido.",
        ERR_SCHEDULE_VACATION_INCOMPLETE:
          "As férias coletivas precisam das duas datas — ou de nenhuma.",
        ERR_SCHEDULE_VACATION_INVERTED:
          "A data final das férias é anterior à inicial.",
        ERR_SETTING_USE_SCHEDULE_ROUTE:
          "O horário de atendimento se grava em Configurações > Horários.",
        ERR_CHANNEL_SEM_EDICAO:
          "Esta conexão não edita mensagem já enviada. O WhatsApp API Oficial não oferece o recurso — reenvie a frase corrigida.",
        ERR_JANELA_DE_EDICAO_EXPIRADA:
          "O WhatsApp só aceita edição nos primeiros 15 minutos depois do envio. Esta mensagem é mais antiga: mande a correção como mensagem nova.",
        ERR_EDITAR_SO_O_QUE_ENVIEI:
          "Só dá para editar mensagem enviada por aqui — o que o cliente escreveu não muda.",
        ERR_EDITAR_SO_TEXTO:
          "Mensagem com arquivo não pode ser editada: nenhum provedor troca o anexo já enviado.",
        ERR_MENSAGEM_APAGADA: "Esta mensagem foi apagada e não pode ser editada.",
        ERR_MENSAGEM_VAZIA: "A mensagem editada não pode ficar vazia.",
        ERR_SUBSCRIPTION_OVERDUE:
          "Assinatura vencida: o acesso está bloqueado até o pagamento ser confirmado. Abra Financeiro > Faturas para pagar ou ver a segunda via.",
        ERR_SUBSCRIPTION_BLOCKED:
          "Assinatura bloqueada. O acesso foi suspenso para esta empresa — fale com o administrador da conta.",
        ERR_SUBSCRIPTION_OVERDUE_NEW_TICKETS:
          "Assinatura vencida: não é possível abrir novos atendimentos. Os atendimentos em andamento seguem funcionando. Abra Financeiro > Faturas para regularizar.",
        ERR_MODULE_NOT_CONTRACTED:
          "Este recurso não faz parte do seu plano. Fale com o administrador da conta para contratá-lo.",
        ERR_CAMPAIGN_NO_PENDING_CONTACTS:
          "Esta campanha não tem contatos para receber. Importe a lista ou escolha uma lista de contatos antes de iniciar.",
        ERR_CAMPAIGN_CANNOT_BE_STARTED:
          "Só dá para iniciar uma campanha em rascunho ou agendada. Esta já está em disparo, foi concluída ou foi cancelada.",
        ERR_CAMPAIGN_CANNOT_BE_CANCELLED:
          "Só dá para cancelar campanha agendada ou em disparo. Esta já terminou ou já foi cancelada.",
        ERR_CAMPAIGN_CANNOT_BE_EDITED:
          "Campanha em disparo ou já concluída não pode ser editada. Cancele antes, ou duplique para montar outra.",
        ERR_CAMPAIGN_INVALID_BODY:
          "Escreva a mensagem da campanha antes de salvar.",
        ERR_CAMPAIGN_NOT_FOUND:
          "Campanha não encontrada. Ela pode ter sido excluída por outra pessoa — recarregue a lista.",
        ERR_CAMPAIGN_NOT_RUNNING:
          "Esta campanha não está em disparo.",
        ERR_CAMPAIGN_RUNNING_CANNOT_DELETE:
          "Campanha em disparo não pode ser excluída. Cancele primeiro e depois exclua.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_INVALID_ACCESS_SETTINGS:
          "Configuração de acesso inválida. Confira horários, IPs, limite de sessões e escopo.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_PLAN_REQUIRED:
          "Escolha um plano para criar a conta.",
        ERR_PLAN_NOT_AVAILABLE:
          "Este plano não está mais à venda. Recarregue a página e escolha outro.",
        ERR_PLAN_LIMIT_STATUS:
          "Você já publicou todos os status do seu plano neste mês.",
        ERR_CONTA_DO_PAINEL_DE_STATUS:
          "Esta conta é do painel de Status. Entre por {{endereco}}.",
        ERR_CONTA_DO_PAINEL_PRINCIPAL:
          "Esta conta não é do painel de Status. Entre pelo painel de atendimento, em {{endereco}}.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_SESSAO_VINCULADA_FORA_DO_AR:
          "A sessão vinculada a esta conexão oficial está fora do ar, e o plano B está para não enviar pela API Oficial. Reconecte a sessão ou mude o plano B na conexão.",
        ERR_CHANNEL_SERVER_NOT_FOUND:
          "Nenhum servidor de canal encontrado com este ID.",
        ERR_CHANNEL_SERVER_INVALID_PROVIDER:
          "Este provider não aceita servidor próprio.",
        ERR_CHANNEL_SERVER_INVALID_NAME:
          "Informe um nome para o servidor.",
        ERR_CHANNEL_SERVER_INVALID_URL:
          "Endereço inválido — precisa começar com http:// ou https://.",
        ERR_CHANNEL_SERVER_INVALID_TOKEN:
          "Informe o token do servidor.",
        ERR_CHANNEL_SERVER_IN_USE:
          "Há conexões usando este servidor. Aponte-as para outro antes de apagar.",
        ERR_NO_WEBHOOK_EVENT_FOUND: "Este evento de webhook não existe mais.",
        ERR_WEBHOOK_EVENT_ALREADY_DONE:
          "Este evento já foi processado — reprocessar repetiria a resposta ao cliente.",
        ERR_WEBHOOK_EVENT_IN_PROGRESS:
          "Este evento está sendo processado agora. Aguarde e atualize a lista.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatória quando há mais de um departamento.",
      },
    },
  },
};

export { messages };
